<template>
  <DisplayContainer label=" Dokumente">
    <v-card>
      <v-tabs v-model="tab" centered icons-and-text>
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#document-archive">
          Dokumente
          <v-icon>mdi-file-document</v-icon>
        </v-tab>

        <v-tab href="#email-archive">
          E-Mails
          <v-icon>mdi-at</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="document-archive">
          <v-card flat>
            <DisplayDocumentArchive
              ref="documentArchiveRef"
              :customerId="customerId"
            />
          </v-card>
        </v-tab-item>
        <v-tab-item value="email-archive">
          <DisplayEmailArchive ref="emailArchiveRef" :customerId="customerId" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </DisplayContainer>
</template>

<script>
import DisplayContainer from '@/components/elements/DisplayContainer.vue';

export default {
  name: 'ArchiveView',
  components: {
    DisplayContainer,
    DisplayDocumentArchive: () =>
      import('@/components/support/DisplayDocumentArchive.vue'),
    DisplayEmailArchive: () =>
      import('@/components/support/DisplayEmailArchive.vue')
  },
  props: {
    customerId: { type: Number, required: true }
  },
  data: () => ({
    tab: null
  }),
  computed: {
    getDocumentTableData() {
      return this.documentTableData;
    }
  },
  mounted: function () {},
  methods: {
    refreshDocuments() {
      this.$refs.documentArchiveRef.loadData();
    },
    refreshEmails() {
      this.$refs.emailArchiveRef.loadData();
    }
  }
};
</script>

<style></style>
